import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {JointType} from '../models';

@Injectable()
export class JointtypeService extends IoService {
  protected model = JointType;
  protected listUrl = '/jointtypes/';
}
